<div class="flex-row navigation-header-item">
  <div class="navigation-header-caption">
    <ng-content></ng-content>
  </div>
</div>
